import React, { useState } from "react";
import { Button } from "components/bootstrap";
import { DATA_LAKE_CONFIG_ACTION } from "data-lake/Types";
import DataLakeBackendFormModal from "data-lake/data-lake-backend-config/DataLakeBackendFormModal";
import LicenseCheck from "license/LicenseCheck";
import { LICENSE_SUBJECTS } from "license/constants";
import useSendTelemetry from "logic/telemetry/useSendTelemetry";
import { TELEMETRY_EVENT_TYPE } from "telemetry/Constants";
import { IfPermitted } from "components/common";
const DataLakeBackendButton = ({ backendId = void 0, buttonType = "button" }) => {
  const action = backendId ? DATA_LAKE_CONFIG_ACTION.Update : DATA_LAKE_CONFIG_ACTION.Create;
  const buttonText = action === DATA_LAKE_CONFIG_ACTION.Update ? "Edit Data Lake Backend" : "Create Data Lake Backend";
  const menuItemText = action === DATA_LAKE_CONFIG_ACTION.Update ? "Edit" : "Create";
  const sendTelemetry = useSendTelemetry();
  const [showModal, setShowModal] = useState(false);
  const onModalClose = () => {
    setShowModal(false);
  };
  const onButtonClick = () => {
    setShowModal(true);
    sendTelemetry(
      TELEMETRY_EVENT_TYPE.DATALAKE[`BACKEND_${action === DATA_LAKE_CONFIG_ACTION.Create ? "CREATE" : "EDIT"}_OPENED`],
      {
        app_pathname: "data-lake"
      }
    );
  };
  const isMenuButton = buttonType === "menuItem";
  return /* @__PURE__ */ React.createElement(LicenseCheck, { licenseSubject: LICENSE_SUBJECTS.archive, hideChildren: true, displayLicenseWarning: false }, showModal && /* @__PURE__ */ React.createElement(DataLakeBackendFormModal, { backendId, onClose: onModalClose }), /* @__PURE__ */ React.createElement(IfPermitted, { permissions: "data_lake_backend_config:update" }, /* @__PURE__ */ React.createElement(Button, { bsStyle: isMenuButton ? "default" : "success", bsSize: "medium", onClick: onButtonClick }, isMenuButton ? menuItemText : buttonText)));
};
export default DataLakeBackendButton;
